import { Pipe, PipeTransform } from '@angular/core';
import { PhoneValidator } from './phone.validator';

/**
 * Pure pipe for list/UI display. Memoized per input value.
 * Pass `false` to omit the +1 country code.
 * Kept in its own file so Angular can resolve it statically in standalone imports.
 */
@Pipe({ name: 'usaPhoneDisplay', standalone: true })
export class UsaPhoneDisplayPipe implements PipeTransform {
  transform(phone: string | null | undefined, withCountryCode = true): string {
    return PhoneValidator.formatUsaPhone(phone, {
      withCountryCode,
      emptyFallback: '-',
    });
  }
}
